<!-- DEV NOTE:
Variant Names:
- primary
- secondary
- text
-->
<template>
	<button
		@click="onClick"
		:class="[
			'btn-classic',
			...variantClassList,
			disabled && 'is-disabled',
			selected && 'is-selected',
			disabled
				? 'is-disabled'
				: isLoading
				? 'is-disabled'
				: hasLoaded
				? 'is-disabled'
				: '',
			isLoading && 'is-loading',
			hasLoaded && 'has-loaded'
		]"
		:title="title"
		:disabled="disabled"
		:type="type"
		:aria-label="ariaLabel"
		@mouseenter="onMouseEnter"
		@mouseleave="onMouseLeave"
		ref="button"
	>
		<span class="btn-classic__icon-before" v-if="iconLeading">
			<i :class="['icon', iconLeadingClassName]"></i>
		</span>

		<slot>
			<span v-if="labelText" class="btn-classic__label">{{
				labelText
			}}</span>
		</slot>

		<span class="btn-classic__icon-after" v-if="iconTrailing">
			<i :class="['icon', iconTrailingClassName]"></i>
		</span>
		<ButtonProgress
			:isLoading="isLoading"
			:hasLoaded="hasLoaded"
			:hasError="hasError"
			:errorMessage="errorMessage"
		/>
		<Tooltip
			trackedRefName="button"
			:visible="validationToolipVisible"
			placement="top"
			positionStrategy="fixed"
			:state="validationTooltipState"
		>
			{{ validationMessage }}
		</Tooltip>
	</button>
</template>

<script>
import baseComponentMixin from '@/mixins/base-component-mixin';
import baseButtonMixin from '@/mixins/base-button-mixin';
import componentVariantMixin from '@/mixins/component-variant-mixin';
import variantClasses from './variant-classes/button-classic-variant-classes';
import ButtonProgress from '@/components/visual/loader/button-progress.vue';
import validationToolipMixin from '@/mixins/validation-tooltip-mixin';
import Tooltip from '@/components/shells/tooltip/tooltip.vue';

/**
 * ButtonClassic
 * @param {('primary'|'secondary'|'text')} variant - the button's visual variation
 */

export default {
	name: 'ButtonClassic',
	mixins: [
		baseComponentMixin,
		baseButtonMixin,
		componentVariantMixin,
		validationToolipMixin
	],
	created() {
		this.variantClasses = variantClasses;
	},
	components: {
		ButtonProgress,
		Tooltip
	}
};
</script>

<style lang="scss" scoped>
/* Both */
.btn-classic {
	@include btn-clear;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	position: relative;
	padding: $btn-padding-y $btn-padding-x;
	background: var(--bg-0);
	color: var(--bg-0-fg-4);
	font-size: $btn-font-size;
	border-radius: $border-radius;
	border: $btn-border;
	cursor: pointer;

	&__icon-before {
		display: inline-flex;
		margin-right: $gutter-md;
	}
	&__icon-after {
		display: inline-flex;
		margin-left: $gutter-md;
	}
}

/* LL styles v1 Only */
.btn-classic {
	&:hover,
	&:focus-visible {
		background: var(--bg-2);
	}
}

/* LL styles v2 Only */
/* .btn-classic {
	&:hover,
	&:focus-visible {
		border-color: transparent;
		background: var(--bg-2);

		&:before {
			@include focus-border($focus-width, $border-radius);
		}
	}

	&--primary {
		background-color: var(--brand-1);
		color: var(--bg-brand-1-fg-2);
		border-color: transparent;

		&:hover,
		&:focus-visible {
			background-color: var(--brand-2);
		}
	}

	&--secondary {
		background-color: var(--bg-brand-2-tint);
		color: var(--bg-brand-2-tint-fg-2);
		border-color: transparent;

		&:hover,
		&:focus-visible {
			background-color: var(--brand-2);
			color: var(--bg-brand-2-fg-2);
		}
	}

	&--text {
		color: var(--brand-2);
		border-color: transparent;

		&:hover,
		&:focus-visible {
			background-color: transparent;
		}
	}
}*/

/* Tweak for Communication Component */
.toast,
.notification-block {
	.btn-classic {
		padding: $padding-xs $padding-sm;
		background: $bg-0;
		color: $bg-0-fg-4;
	}
}
</style>
